import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';

const pad = (n) => String(n).padStart(2, '0');

// Native date inputs use local-time strings: 'YYYY-MM-DD' and 'YYYY-MM-DDTHH:mm'.
const parse = (value) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/.exec(value || '');
    return m ? new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0)) : null;
};

const toValue = (date, withTime) => {
    if (!date) return '';
    const day = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    return withTime ? `${day}T${pad(date.getHours())}:${pad(date.getMinutes())}` : day;
};

/**
 * Drop-in replacement for <input type="date"> and <input type="datetime-local">:
 * the same string `value` and event-style `onChange({ target: { value } })`, but
 * the calendar is the app's react-datepicker, which follows the UI language —
 * a native picker always follows the browser's language instead.
 *
 * `inline` keeps the natural input width (e.g. in a toolbar); otherwise the
 * field fills its container like a form input.
 */
const DateInput = ({ type = 'date', value, onChange, inline = false, placeholder, name, ...rest }) => {
    const { t } = useTranslation();
    const withTime = type === 'datetime-local';

    return (
        <DatePicker
            selected={parse(value)}
            onChange={(date) => onChange && onChange({ target: { value: toValue(date, withTime), name } })}
            dateFormat={withTime ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'}
            showTimeSelect={withTime}
            timeFormat="HH:mm"
            timeIntervals={15}
            timeCaption={t('common.time')}
            todayButton={t('common.today')}
            placeholderText={placeholder}
            name={name}
            autoComplete="off"
            portalId="sbr-dp-portal"
            wrapperClassName={inline ? 'date-input' : 'date-input date-input-block'}
            {...rest}
        />
    );
};

export default DateInput;
